var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_27_50670)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 20,
    height: 20,
    rx: 10,
    fill: "#14B8A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.19844 4.6C7.64027 4.6 7.99844 4.95817 7.99844 5.4V7.081C9.01451 6.04391 10.4309 5.4 11.9984 5.4C14.438 5.4 16.5112 6.95945 17.2796 9.1334C17.4268 9.54997 17.2085 10.007 16.7919 10.1543C16.3753 10.3015 15.9183 10.0832 15.771 9.66659C15.2215 8.11193 13.7388 7 11.9984 7C10.6905 7 9.52807 7.62801 8.79792 8.6H11.1984C11.6403 8.6 11.9984 8.95817 11.9984 9.4C11.9984 9.84183 11.6403 10.2 11.1984 10.2H7.19844C6.75661 10.2 6.39844 9.84183 6.39844 9.4V5.4C6.39844 4.95817 6.75661 4.6 7.19844 4.6ZM7.20497 11.8457C7.62154 11.6985 8.0786 11.9168 8.22584 12.3334C8.77534 13.8881 10.2581 15 11.9984 15C13.3064 15 14.4688 14.372 15.199 13.4L12.7984 13.4C12.3566 13.4 11.9984 13.0418 11.9984 12.6C11.9984 12.1582 12.3566 11.8 12.7984 11.8H16.7984C17.0106 11.8 17.2141 11.8843 17.3641 12.0343C17.5142 12.1843 17.5984 12.3878 17.5984 12.6V16.6C17.5984 17.0418 17.2403 17.4 16.7984 17.4C16.3566 17.4 15.9984 17.0418 15.9984 16.6V14.919C14.9824 15.9561 13.566 16.6 11.9984 16.6C9.55891 16.6 7.48567 15.0405 6.71729 12.8666C6.57006 12.45 6.7884 11.993 7.20497 11.8457Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_27_50670",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_27_50670"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_27_50670",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/reset.fd796d11154da017fbf930a65edbfc3f.svg";
export { ForwardRef as ReactComponent };